import "./recreation-and-sports.scss";
type RecreationAndSportsPageProps = {};

const RecreationAndSportsPage = (props: RecreationAndSportsPageProps) => {
  return (
    <>
      <div className="recreation-and-sports page">
        <div className="recreation-and-sports__header page__header">
          <h1 className="recreation-and-sports__header__title page__header__title">
            ОРГАНИЗИРАН ОТДИХ И СПОРТ
          </h1>
        </div>
        <div className="recreation-and-sports__body">
          <h1 className="recreation-and-sports__body__title">
            Организиран отдих и физическа активност
          </h1>
          <div className="recreation-and-sports__body__content">
            <p className="recreation-and-sports__body__content__item">
              В часовете по организиран отдих и физическа активност учениците
              заменят умствената дейност с разнообразни спортни игри и разходки.
              Получават здравословна и вкусна храна,която отговаря на всички
              хигиенни изисквания.
            </p>
            <p className="recreation-and-sports__body__content__item">
              Дейностите по организиран отдих и спорт на учениците не се
              провеждат в учебните помещения, в които се водят часовете от
              задължителната подготовка.
            </p>
            <p className="recreation-and-sports__body__content__item">
              Дейностите по организиран отдих и спорт включват:
            </p>
            <ol className="recreation-and-sports__body__content__list">
              <li className="recreation-and-sports__body__content__list__item">
                <p>Организиране на обедното хранене на учениците</p>
              </li>
              <li className="recreation-and-sports__body__content__list__item">
                <p>
                  Организиране и координиране на дейностите по отдиха и
                  спортните игри на учениците
                </p>
              </li>
              <li className="recreation-and-sports__body__content__list__item">
                <p>
                  Наблюдение и оценка на поведенческите ситуации по време на
                  организирания отдих и спорт на учениците
                </p>
              </li>
              <li className="recreation-and-sports__body__content__list__item">
                <p>
                  Провеждане на беседи и разговори с учениците по възникнали
                  затруднения, споделяне на проблеми, възникнали конфликти и
                  други
                </p>
              </li>
              <li className="recreation-and-sports__body__content__list__item">
                <p>
                  Спазване на здравно-хигиенните норми и изисквания от учениците
                </p>
              </li>
              <li className="recreation-and-sports__body__content__list__item">
                <p>Грижа за опазване здравето и живота на децата и учениците</p>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </>
  );
};

export default RecreationAndSportsPage;
